import './components/kb-app.js'

var app = {

    // Application Constructor
    initialize: function() {
        window.addEventListener('load', this.onDeviceReady.bind(this), false);
    },

    onDeviceReady: function(id) {
        var el = document.createElement("kb-app");
		el.style.display = "flex";
		el.style.flexDirection = "column"
        document.querySelector("main").appendChild(el);    
    
        /////////////////////////////////////////////////////////////////////////////

 		  // Get the CSS filenames from the specified "theme" folder, and dynamically
 		  // create the <link> elements for each file.
        // The "theme" folder will be a folder under /webapps/kb/themes in the tomcat 
        // environment. The "theme" is a global variable declared in "index.html",
        // intended to be modified by the user.
        
       /**
        *  MC - 2022-Jul-4
        *  Returns a list of CSS filenames in the "theme" folder, as a 
        *  comma-separated string value.
        */
       const filenames = fetch("/kb/jrest/getCSSForTheme?theme=" + theme)
          .then ((response) => response.text() )
          .then ((response) => { return response; 
       });

		 const renderCSSLinks = async () => {
    	    const cssFiles = await filenames;
    		 console.log ("Filenames:  " + cssFiles);   
    	 	 
    		 if (cssFiles != "undefined")
    		 {
    		    // split into array
    		    let cssFilenames = cssFiles.split(',');
				 if (cssFilenames != "undefined" && cssFilenames.length > 0)
				 {
				 	 cssFilenames.forEach((cssfile) => 
				 	 {
				 	 	 if (cssfile.length > 0)
				 	 	 {
		                var fileref = document.createElement("link");
		                fileref.rel = "stylesheet";
		                fileref.type = "text/css";
		                fileref.href = "/kb/themes/" + theme + "/" + cssfile;
		                document.getElementsByTagName("head")[0].appendChild(fileref);
		             }
					 });
    		    }
    		 }	    	        
		 };

		 renderCSSLinks();

       /////////////////////////////////////////////////////////////////////////////

      }
    };

app.initialize();
